var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWithdrawn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 65.74 65.74"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.87.9C15.21.9.9 15.21.9 32.87s14.31 31.97 31.97 31.97 31.97-14.31 31.97-31.97S50.53.9 32.87.9zm0 57.75c-14.24 0-25.78-11.54-25.78-25.78S18.62 7.09 32.87 7.09s25.78 11.54 25.78 25.78-11.54 25.78-25.78 25.78z",
    stroke: "#3d3d3c",
    strokeWidth: 1.8,
    fill: "#ef4540"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef4540",
    stroke: "#010101",
    strokeWidth: 1.2,
    d: "M32.4 30.15l4.75 16.75h4.29l7.46-26h-5.11l-4.48 16.64-4.79-16.64h-4.24l-4.79 16.64-4.48-16.64H15.9l7.46 26h4.29l4.75-16.75z",
    "data-name": "W"
  }))));
}
export default SvgWithdrawn;